export enum OrdersApiTags {
  orderForm = "orderForm",
  orderResponse = "orderResponse",
}
